@if (loading) {
  <lib-skeleton-card-table></lib-skeleton-card-table>
} @else {
  @for (freight of freights$ | async; track freight.id) {
    <lib-freight-shipper-card [freight]="freight"></lib-freight-shipper-card>
  } @empty {
    <lib-empty-result text="freight.general.without_freights"></lib-empty-result>
  }
}
